import { createStore } from "redux";
import setupStore from "../reducers/main.reducer";
import { History } from "history";

export default function (history: History) {
    return setupStore(history);
}



// WEBPACK FOOTER //
// ./src/stores/main.store.ts